import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';
import { ApiCallHandler } from './models/apiCallHandler';
import { IHttpParams } from 'ngx-eo-web-components';
import { STATUS } from './models/loading-status.enum';
import { environment } from '../../../environments/environment';
import { Confirmation, ConfirmationService, MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  static injector: Injector;

  private subscriptions: Subscription[] = [];
  public isMobile$ = new BehaviorSubject<boolean | null>(false);


  // private token$ = this.authService.token$;

  roles: string[] = [];
  useremail: string = '';

  constructor(
    private injector: Injector,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {
    CoreService.injector = this.injector;
    // this.subscriptions = [
    //   this.token$.subscribe((t) => {
    //     this.roles = t?.role?.split(',') ?? [];
    //     this.useremail = t?.email ?? '';
    //   }),
    // ];
    //this.authService.TokenExpirationCheck();
  }

  hasRoles(userRoles: string[]) {
    return userRoles.some((r) => this.roles.includes(r));
  }

  public initCall<T>(
    apiPath: string,
    apiCallHandler: ApiCallHandler<T>
  ): IHttpParams;
  public initCall<T>(
    apiPath: string,
    apiCallHandler: ApiCallHandler<T>,
    requestBody?: any
  ): IHttpParams;
  public initCall<T>(
    apiPath: string,
    apiCallHandler: ApiCallHandler<T>,
    requestBody?: any,
    options?: any
  ): IHttpParams;
  public initCall<T>(
    apiPath: string,
    apiCallHandler: ApiCallHandler<T>,
    requestBody?: any,
    options?: any
  ): IHttpParams {
    // apiCallHandler.status$.next(STATUS.loading);
    // apiCallHandler.error$.next(null);
    let result: IHttpParams = {
      ...{
        url: `${environment.apiUrl}${apiPath}`,
        success$: apiCallHandler.data$,
        status$: apiCallHandler.status$,
        error$: apiCallHandler.error$,
      },
      ...(requestBody != undefined && { body: requestBody }),
      options: { ...options },
    };

    return result;
  }

  successCall<T>(data: T, apiCallHandler: ApiCallHandler<T>) {
    apiCallHandler.data$.next(data);
    apiCallHandler.status$.next(STATUS.success);
  }

  errorCall<T>(errorMessage: string, apiCallHandler: ApiCallHandler<T>) {
    apiCallHandler.error$.next(errorMessage);
    apiCallHandler.status$.next(STATUS.error);
  }

  downLoadFile(data: any, type: string, filename: string) {
    try {
      // Create a Blob with the provided data
      const blob = new Blob([data], { type: type });

      // Log the blob size for debugging purposes
      if (blob.size === 0) {
        return;
      }

      // Create a temporary download link
      const downloadLink = document.createElement('a');
      const url = window.URL.createObjectURL(blob);

      downloadLink.href = url;
      downloadLink.setAttribute('download', filename);

      // Append the link to the document to make it clickable
      document.body.appendChild(downloadLink);
      downloadLink.click();

      // Clean up
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(url);
    } catch (error) {
    }
  }

  downLoadExcelFile(data: any, filename: string) {
    this.downLoadFile(
      data,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      filename
    );
  }

  showError(message: string) {
    this.messageService.add({
      severity: 'error',
      summary: 'Παρουσιάστηκε σφάλμα',
      detail: message,
    });
  }

  showSuccess(message: string, title: string = 'Επιτυχής ενέργεια') {
    this.messageService.add({
      severity: 'success',
      summary: title,
      detail: message,
    });
  }

  setIsMobile(isMobile: boolean) {
    this.isMobile$.next(isMobile);
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subscriptions.forEach((s) => s.unsubscribe);
  }

  confirmDialog(options: Confirmation) {
    this.confirmationService.confirm({
      key: 'def',
      header: 'Είστε σίγουροι;',
      message: `Είστε σίγουροι ότι θέλετε να προχωρήσετε;`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Εντάξει',
      acceptIcon: '-',
      rejectLabel: 'Άκυρο',
      rejectButtonStyleClass: 'p-button-outlined',
      rejectIcon: '-',
      ...options,
    });
  }
}
